import React, { Component } from 'react';
import Header from '../../components/main.header.component';


class Divercity extends Component {
  render() {
    return (
      <div className="Divercity">
        <Header
          props={this.props}
        />
          <div className="divercity-headline">
            <a href="https://www.divercity.io" target='_blank' rel="noopener noreferrer">
              Divercity.io
            </a>
          </div>
          <div className="divercity-text">
            <h4>The worlds largest minority professional network for diversity & inclusion recruiting</h4>
            <ul>
              <li>Single handedly developed entire front-end web app using Node.JS, React with Redux.</li>
              <li>Worked hand-in-hand with UX designers to produce thoughtful UI designs and implemented pixel-perfect CSS designs.</li>
              <li>Constructed a custom live-chat messaging system, built from scratch using WebSockets. </li>
            </ul>
          Built with: React, Redux, Node.js, CSS3, ES6 and GraphQL.
          </div>

          <div className="divercity-blue">
            <video id="divercity-video" controls >
              <source src="/images/divercity/groups.mov" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="divercity-goals">
            <div className="divercity-text">
              <h2>Features</h2>
              <ul>
                <li>
                  As a Recruiter or Hiring Manager, you can easily post jobs, create a company profile, import your Greenhouse job listings, and connect with applicants.
                </li>
                <li> Job Seekers are able to browse a jobs feed designed to avoiding all the problems of other job sites. <br />
                (View Job opens a modal so you don't lose your place in the feed, as well as being able to quickly apply with one button).<br />
                  Job filters for required experience, industry, and location allow for a smooth experience.
                  </li>
                <li> In-house engineered chat messaging app allows quick communication across the web and mobile application.</li>
              </ul>
            </div>
          </div>
          <div className="divercity-blue">
            <video id="divercity-video" controls >
              <source src="/images/divercity/jobs.mov" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
      </div>
    );
  }
}

export default Divercity;


          // <div id="divercity-link">
          //   <a href="https://www.divercity.io" target='_blank' rel="noopener noreferrer">
          //     View the Site
          //   </a>
          // </div>